import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true, // send session_token cookie
});

// Attach JWT (email/password) bearer if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("afb_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const setToken = (t) => {
  if (t) localStorage.setItem("afb_token", t);
  else localStorage.removeItem("afb_token");
};
export const getToken = () => localStorage.getItem("afb_token");
